module.exports = "/_next/static/images/Survey-afe8ac211962d2216b861a22bea7aae1.svg";